import {DivIcon} from "leaflet";
import {TARGET_POINT_ICON_SINGLE_VOYAGE} from "./pointIcon";
import {sliceString} from "@helpers/string";


const buildNumber = (
    number: number,
    bgColor?: string,
    borderColor?: string,
    children?:string
) => {
    const borderStyles = borderColor ? `border:3px solid ${borderColor};` : ''
    return `<div 
                style="font-weight:600;color:#602e2f;font-size: 12px;background-color: ${bgColor ?? '#f1a378'};border-radius: 50%;display: flex;justify-content: center;align-items: center;width: 30px;height: 30px;${borderStyles};position: relative">
                    ${number}
                    ${children ? children : ''}
            </div>`
}


export const buildPointEntryRadiusIconSingleVoyage = (size: number) => `<div style="transform:translate(-50%,-50%);position: absolute;left: 50%;top:50%;z-index: -1;width: ${size}px;height: ${size}px;background-color: rgba(46, 190, 253, 0.2);border-radius: 50%"></div>`
export const buildPointEntryRadiusIconRelativeSingleVoyage = (size: number) => `<div style="width: ${size}px;height: ${size}px;background-color: rgba(46, 190, 253, 0.2);border-radius: 50%"></div>`

export const buildPointIconSingleVoyageNameSingleVoyage = (
    name: string,
    active?: boolean,
) =>
    `<div 
        class="darkThemeBgGray"
        style="font-weight:600;font-size: 10px;text-align:center;background-color:${active ? '#2ebefd' : '#fff'};box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);border-radius: 4px;padding: 1px 4px;white-space: nowrap;overflow: hidden;width: 95px;position: relative;"
    >
        ${sliceString(name, 13)}
    </div>`

export const buildPointIconSingleVoyageHtmlSingleVoyage = ({
                                                               number,
                                                               name,
                                                               active,
                                                               bgColor,
                                                               showEntryRadius,
                                                               entryRadiusSize,
                                                               borderColor,
                                                           }: {
    number: number,
    name?: string,
    active?: boolean,
    bgColor?: string,
    showEntryRadius?: boolean,
    entryRadiusSize?: number,
    borderColor?: string,
}) => {
    const radius = showEntryRadius && entryRadiusSize ? buildPointEntryRadiusIconSingleVoyage(entryRadiusSize) : ''

    return `<div
                style="display: flex;justify-content: center;flex-direction: column;align-items: center;gap: 4px;position: relative;"
                >
                ${active ? TARGET_POINT_ICON_SINGLE_VOYAGE : ''}
                ${buildNumber(number, bgColor, borderColor,radius)}
                ${name ? buildPointIconSingleVoyageNameSingleVoyage(name, active) : ''}
                </div>`
}

// heights of the icon parts, see buildPointIconSingleVoyageHtmlSingleVoyage: pin + gap, number circle, gap + name
const PIN_BLOCK_HEIGHT = 34
const CIRCLE_SIZE = 30
const NAME_BLOCK_HEIGHT = 21

/**
 * Pins the icon to the centre of the number circle. The parts are stacked and centred in the icon
 * box, so without this leaflet puts the point in the middle of the whole stack, off the circle.
 */
const getIconAnchorSingleVoyage = (height: number, active: boolean, hasName: boolean): [number, number] => {
    const pin = active ? PIN_BLOCK_HEIGHT : 0
    const content = pin + CIRCLE_SIZE + (hasName ? NAME_BLOCK_HEIGHT : 0)
    return [95 / 2, (height - content) / 2 + pin + CIRCLE_SIZE / 2]
}

export const buildPointIconSingleVoyage = ({
                                               number,
                                               active,
                                               name,
                                               bgColor,
                                               showEntryRadius,
                                               entryRadiusSize,
                                               className,
                                               borderColor,
                                           }: {
    number: number,
    name: string,
    active?: boolean,
    bgColor?: string,
    showEntryRadius?: boolean,
    entryRadiusSize?: number,
    className?: string
    borderColor?: string
}) => {
    return new DivIcon({
        html: buildPointIconSingleVoyageHtmlSingleVoyage({
            name,
            active,
            number,
            bgColor,
            showEntryRadius,
            entryRadiusSize,
            borderColor,
        }),
        popupAnchor: [active ? -10 : 0, active ? -70 : -40],
        iconSize: [95, active ? 89 : 53],
        iconAnchor: getIconAnchorSingleVoyage(active ? 89 : 53, !!active, !!name),
        className: className ? `${className} mutate-point-signe-voyage` : 'mutate-point-signe-voyage',
    });
}